import React from 'react';
import { Link } from 'react-router-dom';

import { DESKTOP_BREAK_POINT } from 'app/constants';
import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    className?: string;
}

const Logo: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <Link to={'/'} className={cx(classes.root, className)}>
            <picture>
                <source
                    srcSet={Utils.getImage('logo_small')}
                    media={`(max-width: ${DESKTOP_BREAK_POINT}px)`}
                    width={40}
                />
                <source srcSet={Utils.getImage('logo')} media={`(min-width: ${DESKTOP_BREAK_POINT}px)`} width={170} />
                <img className={classes.image} src={Utils.getImage('logo')} alt="Logo" />
            </picture>
            <span className={classes.text}>{'Vulners'}</span>
        </Link>
    );
};

export default Logo;
